// extracted by mini-css-extract-plugin
export var mb8 = "Typography-module__mb8___hMCnK";
export var mb12 = "Typography-module__mb12___eflSZ";
export var mb16 = "Typography-module__mb16___yv1Zf";
export var mb24 = "Typography-module__mb24___cn7Th";
export var mb32 = "Typography-module__mb32___j7V10";
export var mb48 = "Typography-module__mb48___GZRhU";
export var mb64 = "Typography-module__mb64___OjQxf";
export var mt2Xl = "Typography-module__mt2xl____f1he";
export var heading100 = "Typography-module__heading100___UMX71";
export var heading200 = "Typography-module__heading200___mIPsJ";
export var heading300 = "Typography-module__heading300___qwTSP";
export var heading400 = "Typography-module__heading400___a09zB";
export var heading500 = "Typography-module__heading500___g3UMN";
export var heading600 = "Typography-module__heading600___bsvHb";
export var heading700 = "Typography-module__heading700___DwhPi";
export var paragraph100 = "Typography-module__paragraph100___KIcWh";
export var paragraph200 = "Typography-module__paragraph200___DE2no";
export var paragraph300 = "Typography-module__paragraph300___smz48";
export var text100 = "Typography-module__text100___aXLis";
export var text100Bold = "Typography-module__text100bold___wIhaf";
export var text200 = "Typography-module__text200___JdUta";
export var text200Bold = "Typography-module__text200bold___Hb7_a";
export var text300 = "Typography-module__text300___yZk3H";
export var text300Bold = "Typography-module__text300bold___JTmBf";
export var secondary = "Typography-module__secondary___mHCN1";
export var error = "Typography-module__error___Yg8ag";
export var inverse = "Typography-module__inverse___VbiAG";